import { TextareaHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../Typography';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  showCharacterCount?: boolean;
}

export default function TextArea({
  className,
  showCharacterCount,
  maxLength,
  value,
  ...props
}: Props) {
  const currentLength = String(value ?? '').length;

  return (
    <div className="relative">
      <textarea
        className={twMerge([
          'placeholder:text-grey-500 hover:border-black-400 focus:border-primary-300 w-full resize-none rounded-xl border border-gray-100 px-[14px] py-3 text-base shadow-[0px_1px_2px_0px_#1018280D] outline-hidden transition-all duration-150 focus:shadow-[0px_0px_0px_4px_#D1E9FF]',
          showCharacterCount && 'pb-8',
          className,
        ])}
        value={value}
        maxLength={maxLength}
        {...props}
      />
      {showCharacterCount && (
        <Typography
          variant="body-sm"
          className="pointer-events-none absolute right-4 bottom-4 text-sm !text-gray-500 tabular-nums"
        >
          {currentLength}
          {maxLength && `/${maxLength}`}
        </Typography>
      )}
    </div>
  );
}
